@if (selectedDataClass) {
<div class="col th-p notification-content-wrapper">
  <header class="top-box-shadow elibraryTileView" style="display: none">
    <div class="columns is-gapless is-vcentered is-mobile">
      <!-- <figure class="has-text-centered">
        <i class="hideMobileView fa" [ngClass]="{'fa-angle-double-left':!this.ailibraryComponent.viewLibraryList,'fa-angle-double-right': this.ailibraryComponent.viewLibraryList}"
        (click)="hideElibaryClass()"></i>
      </figure> -->
      <div class="column is-4">
        @if (isUserRole===1) {
        <a
          class="is-link is-small mar-0-15 has-tooltip-right"
          (click)="editClassesLesson()"
          data-tooltip="Edit Policy"
        >
          <i class="fa fa-pencil fa-font-size pad-7-2"></i>
        </a>
        }
        <h3 class="is-marginless is-clearfix">
          <span
            class="is-size-6 has-text-weight-semibold ellipsis"
            style="max-width: 80%; display: inline-block"
            title="{{ selectedDataClass.chat_group_name }}"
            >{{ selectedDataClass.chat_group_name }}
          </span>
          <small
            class="display-b is-size-7 text-clr-grey"
            style="white-space: nowrap"
            >{{ selectedDataClass.updatedAt | date : "MMM d, y h:mm a" }}</small
          >
        </h3>
      </div>
      <div
        class="column is-8 has-text-right"
        style="position: absolute; right: 5px"
      >
        <div class="is-flex" style="justify-content: flex-end">
          <div class="field headerSearch" style="margin: 0px 15px">
            <div class="control has-icons-left has-icons-right">
              <input
                class="input is-small"
                type="text"
                placeholder="Search"
                [(ngModel)]="search"
                (keyup)="searchSubject.next($event)"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-search"></i>
              </span>
              @if (search) {
              <span class="icon is-small is-right">
                <i
                  class="fa fa-close"
                  style="cursor: pointer"
                  (click)="clearSearchFileList()"
                ></i>
              </span>
              }
            </div>
          </div>
          @if (!activeDashboard) {
          <div class="desk-view header-elibrary" style="display: flex">
            <!-- <a class="actionBtnMobileView" >
              <button class="button is-link is-outlined is-small" data-toggle="collapse" data-target=".search-input" (click)="clickedSearchIcon($event)">
                <i class="fa fa-search" aria-hidden="true"></i>
              </button>
              <div class="showSearchBox" *ngIf="showSearchBar">
                <div class="field headerSearch" style="margin: 0px 15px;">
                  <div class="control has-icons-left has-icons-right">
                    <input class="input is-small" type="text" placeholder="Search" [(ngModel)]="search" (keyup)="searchSubject.next($event)">
                    <span class="icon is-small is-left">
                      <i class="fa fa-search"></i>
                    </span>
                    <span class="icon is-small is-right" *ngIf="search">
                      <i class="fa fa-close" style="cursor: pointer;" (click)="clearSearchFileList()"></i>
                    </span>
                  </div>
                </div>
              </div>
            </a> -->
            <!-- <a class="actionBtnDeskandMobView" (click)="showHideModal('dashboard')">
            <button class="button is-link is-outlined is-small">
              <i class="fa-solid fa-gauge"></i>
            </button>
          </a> -->
            <div class="tabs is-toggle is-toggle-rounded">
              <ul>
                <li
                  class=""
                  [ngClass]="{ 'is-active': activeTileView }"
                  data-tooltip="E Library Tile View"
                >
                  <a class="" (click)="showHideModal('tile')">
                    <span class="icon is-small"><i class="fa fa-th"></i></span>
                  </a>
                </li>
                <li
                  [ngClass]="{ 'is-active': activeListView }"
                  data-tooltip="E Library List View"
                >
                  <a class="" (click)="showHideModal('list')">
                    <span class="icon is-small"
                      ><i class="fa fa-list"></i
                    ></span>
                  </a>
                </li>
              </ul>
            </div>
            @if (isUserRole!=1) {
            <span style="margin-right: 30px"></span>
            } @if (isUserRole===1) {
            <a
              class="upload actionBtnDeskView"
              (click)="showHideModal('upload')"
            >
              <button class="button is-link is-small hidBtnUpload">
                <i class="fa fa-upload"></i> Upload Content
              </button>
            </a>
            } @if (isUserRole===1) {
            <a class="actionBtnMobileView" (click)="showHideModal('upload')">
              <button class="button is-link is-small hidBtnUpload">
                <i class="fa fa-upload"></i>
              </button>
            </a>
            }
            <a class="actionBtnMobileView" (click)="closeActiveClass()">
              <button class="button is-link is-small">
                <i class="fa fa-times" aria-hidden="true"></i>
              </button>
            </a>
          </div>
          } @if (activeDashboard) {
          <div class="desk-view header-elibrary">
            <a
              class="has-tooltip-left hideDashboard"
              (click)="disabledDashboard()"
              data-tooltip="Close Dashboard"
            >
              <button class="button is-link is-outlined is-small">
                <i class="fa fa-th" aria-hidden="true"></i>
              </button>
            </a>
          </div>
          }
        </div>
      </div>
    </div>
  </header>
  <div class="row mt-2 elibrary-filter" [hidden]="activeFileUploadHeader">
    <div class="col-md-4 px-3">
      <div class="d-flex flex-row align-items-center">
        <!-- <figure class="has-text-centered">
      <i class="hideMobileView fa-solid" [ngClass]="{'fa-chevron-left':!ailibrary.viewLibraryList,'fa-chevron-right':ailibrary.viewLibraryList}"
      (click)="hideElibaryClass()"></i>
    </figure>   -->
        <!-- <img style="width:45px;" [src]="profileUrl+updatedGroupList.chat_group_icon" *ngIf="updatedGroupList.chat_group_icon">
    <empty-uname [userName]="updatedGroupList.chat_group_name" [liProfile]="true" *ngIf="!updatedGroupList.chat_group_icon"></empty-uname>
    -->
        <span class="ms-2">
          <h3 class="is-clearfix ms-0">
            <span
              class="is-size-6 has-text-weight-semibold ellipsis"
              style="display: inline-block"
              title="{{ selectedDataClass.chat_group_name }}"
              >{{ selectedDataClass.chat_group_name }}
            </span>
            @if (isUserRole===1) {
            <a
              class="is-link is-small mar-0-15 has-tooltip-right"
              (click)="editClassesLesson()"
              data-tooltip="Edit Library"
            >
              <i class="fa fa-pencil fa-font-size pad-7-2"></i>
            </a>
            }
          </h3>
          <span class="display-flex">
            <small class="display-b is-size-7" style="white-space: nowrap">{{
              selectedDataClass.updatedAt | date : "MMM d, y h:mm a"
            }}</small>
          </span>
        </span>
      </div>
    </div>
    <div class="col-md-8 py-1">
      <div class="d-flex flex-row align-items-center justify-content-lg-end">
        <!-- <select class="form-select me-2" [(ngModel)]="fileFilter" (change)="onfileFilterSelected($event)">
    <option value="all">All</option>
    <option value="llm">Trained Files</option>
    <option value="non-llm">Not Trained Files</option>
  </select> -->
        @if (isUserRole===1) {
        <a
          class="upload actionBtnDeskView has-tooltip-bottom"
          placement="bottom"
          data-tooltip="Upload Content"
          (click)="showHideModal('upload')"
        >
          <button class="button is-link is-small hidBtnUpload">
            <i class="fa fa-upload"></i>
          </button>
        </a>
        }&nbsp;&nbsp;&nbsp;
        <!-- <a class="actionBtnDeskandMobView" (click)="showHideModal('dashboard')" *ngIf="!activeDashboard">
    <button class="button is-link is-outlined is-small">
      <i class="fa-solid fa-gauge"></i>
    </button>
  </a>
  <a class="actionBtnDeskandMobView" (click)="showHideModal('tile')" *ngIf="activeDashboard">
    <button class="button is-link is-outlined is-small">
      <i class="fa-solid fa-th"></i>
    </button>
  </a> -->
        <span class="field" style="margin: 0px 15px">
          <div class="control has-icons-left has-icons-right">
            <input
              class="input is-small"
              type="text"
              placeholder="Search"
              [(ngModel)]="search"
              (keyup)="searchSubject.next($event)"
            />
            <span class="icon is-small is-left">
              <i class="fa fa-search"></i>
            </span>
            @if (search) {
            <span class="icon is-small is-right">
              <i
                class="fa fa-close"
                style="cursor: pointer"
                (click)="clearSearchFileList()"
              ></i>
            </span>
            }
          </div>
        </span>
      </div>
    </div>
  </div>
  <div class="contents pos-relative">
    @if (!this.viewControl.editClassesDetails) {
    <div
      class="notifications scroll-bar"
      appInfiniteScroll
      (reachedBottom)="onScrollDown()"
      infinite-scroll
      [infiniteScrollDistance]="modalScrollDistance"
      [infiniteScrollThrottle]="modalScrollThrottle"
      [scrollWindow]="false"
      (scrolled)="onScrollDown()"
    >
      @if (!activeListView && activeTileView && !activeDashboard &&
      !activeFileUpload) {
      <div class="chat-list msg-list-view">
        <app-ai-library-tile
          [groupName]="selectedDataClass.chat_group_name"
          [classFileList]="getElibraryFileList"
          [totalUserCount]="getUserCount"
          [userReadCount]="getReadUserCount"
          [selectedClassList]="groupUserList"
          [getSearchLessonList]="getSearchItem"
        ></app-ai-library-tile>
      </div>
      }
      <!-- <div class="chat-list mar-0-15" *ngIf="activeListView && !activeTileView && !activeDashboard && !activeFileUpload">
      <app-e-library-list [classFileList]="getElibraryFileList" [totalUserCount]="getUserCount"></app-e-library-list>
    </div> -->
      @if (!activeListView && !activeTileView && activeDashboard &&
      !activeFileUpload) {
      <div class="chat-list mar-0-15">
        <app-ai-library-dashboard
          [classFileList]="getElibraryFileList"
          [gridUserCount]="selectedClass"
          [gridCountFileList]="getLessonCount"
        ></app-ai-library-dashboard>
      </div>
      }
      <pagination-loader
        [showFetchLoader]="showPaginateSpinner"
      ></pagination-loader>
    </div>
    }
    <!-- <div class="scroll-bar" *ngIf="this.viewControl.editClassesDetails">
<div class="column">
  <div class="columns">
    <div class="column is-half is-offset-one-quarter">
      <div class="columns new-chat mar-top15">
        <div class="column">
          <div class="card">
            <div class="card-content">
              <div class="content form-style">
                <form [formGroup]="newGroupForm" novalidate>
                  <h3>Policy</h3>
                  <div class="columns">
                    <div class="column">
                      <div class="field">
                        <div class="control profile-img">
                          <empty-uname [userName]="updatedGroupList.chat_group_name" [detailProfile]="true" *ngIf="!updatedGroupList.chat_group_icon"></empty-uname>
                          <img [src]="profileUrl+updatedGroupList.chat_group_icon" *ngIf="updatedGroupList.chat_group_icon">
                          <span class="img-options">
                            <div class="dropdown is-hoverable">
                              <div class="dropdown-trigger">
                                <i class="fa fa-camera"></i>
                              </div>
                              <div class="dropdown-menu" id="dropdown-menu4" role="menu">
                                <div class="dropdown-content">
                                  <a class="dropdown-item">
                                    <label class="file-label">
                                      <input class="file-input" name="profile" id="profile" type="file" (change)="onFileChange($event)" [disabled]="selectedFileList.length > 0"
                                      #fileInput accept=".jpg, .jpeg, .png, .svg">
                                      <span class="file-label">Update Picture</span>
                                    </label>
                                  </a>
                                  <a class="dropdown-item" *ngIf="updatedGroupList.chat_group_icon" (click)="deleteGroupProfile()">Remove Picture</a>
                                </div>
                              </div>
                            </div>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="columns">
                    <div class="column is-12">
                      <div class="field">
                        <label class="label">Title
                          <span class="required">*</span>
                        </label>
                        <div class="control">
                          <input class="input" type="text" placeholder="" formControlName="chat_group_name">
                          <form-validation [control]="newGroupForm.controls.chat_group_name"></form-validation>
                        </div>
                      </div>
                    </div>
                    <div class="column is-6" style="display: none;">
                      <div class="field">
                        <label class="label">Privacy</label>
                        <div class="control">
                          <div class="select is-fullwidth">
                            <select formControlName="is_private">
                              <option value>--Select--</option>
                              <option *ngFor="let privacy of privacyList" value="{{privacy.value}}">{{privacy.name}}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="columns">
                    <div class="column">
                      <div class="field">
                        <label class="label">Description</label>
                        <div class="control">
                          <textarea class="textarea" placeholder=""  formControlName="chat_description" rows="2" (keydown)="keyDownHandler($event)" ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="columns">
                    <div class="column is-8">
                      <label class="label class_list" data-tooltip="List of users who are already added to this Policy">Access Users
                      </label>
                    </div>
                    <div class="column is-4" style="position: relative;right:-14px">
                      <button type="button" class="button is-small is-link" [disabled]="!newGroupForm.valid" (click)="openAddUserSection()">Add More Users</button>
                      <p class="display-ib mar-10-0" *ngIf="selectedIdList.length > 0">
                        <em> {{selectedIdList.length}} User selected </em>
                      </p>
                    </div>
                  </div>
                  <div class="columns activeGroupUser">
                    <div class="column">
                      <div class="field pos-relative scroll-bar" >
                        <div class="panel pos-relative scroll-bar" infinite-scroll [infiniteScrollDistance]="modalScrollDistance" [infiniteScrollThrottle]="modalScrollThrottle"
                          [scrollWindow]="false" (scrolled)="onScrollDown()">
                          <div class="existing_student" *ngFor="let user of userList">
                            <label class="panel-block pos-relative groupUserList"  >
                              <div class="chat-user-status" >
                                <empty-uname [userName]="user.full_name" [liProfile]="true" *ngIf="!user.user_icon"></empty-uname>
                                <img [src]="profileUrl+user.user_icon" class="image is-48x48" *ngIf="user.user_icon">
                              </div>
                              <div class="mar-0-10">
                                <span class="display-b is-capitalized"> {{ user.full_name }}</span>
                                <p class="is-size-7" *ngIf="user.is_online" [ngClass]="{'circle-grey': user.user_status === 0, 'circle-green':user.user_status === 1, 'circle-red':user.user_status === 2, 'circle-yellow':user.user_status === 3}">{{user.status_name}}</p>
                                <p class="is-size-7 text-clr-grey" *ngIf="!user.is_online">{{user.last_seen | amTimeAgo}}</p>
                                <a class="button is-primary is-outlined is-small time-ago" *ngIf="user.is_group_admin" style="font-size: 10px;margin: 5px;">Admin</a>
                              </div>
                              <a class="icon is-small icon-align is-pulled-right delete-user has-tooltip-left" *ngIf="!user.is_group_admin" (click)="deleteGroupUser(user.user_id)" data-tooltip="Remove User">
                                <i class="fa fa-trash" aria-hidden="true"></i>
                              </a>
                            </label>
                          </div>
                          <pagination-loader [showFetchLoader]="showPaginateSpinner"></pagination-loader>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="columns display-flex is-clearfix">
                    <div class="column is-12">
                      <div class="has-text-right">
                        <button class="button mar-0-5 is-small" (click)="closeClassesDetails()">Cancel</button>
                        <button class="button is-link is-small" [disabled]="(newGroupForm.valid && !newGroupForm.dirty) || newGroupForm.invalid" (click)="updateGroupDetail(newGroupForm.value)">Update</button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div> -->
  </div>
</div>
}

<!-- <div class="chat-list mar-0-15" *ngIf="!activeListView && !activeTileView && !activeDashboard && activeFileUpload">
<app-e-library-upload [selectedClassList]="groupUserList"></app-e-library-upload>
</div> -->

@if (activeFileUpload) {
<div class="modal fade show policy-upload">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ selectedDataClass.chat_group_name }}</h5>
        <span class="pull-right" (click)="hideFileUploadModal()"
          ><i class="fa-solid fa-times"></i
        ></span>
      </div>
      <div class="modal-body">
        <app-ai-library-upload
          [selectedClassList]="groupUserList"
        ></app-ai-library-upload>
      </div>
    </div>
  </div>
</div>
} @if (this.viewControl.editClassesDetails) {
<div class="modal fade show">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Edit Library</h5>
        <span class="pull-right" (click)="closeClassesDetails()"
          ><i class="fa-solid fa-times"></i
        ></span>
      </div>
      <div class="modal-body">
        <form [formGroup]="newGroupForm" novalidate>
          <div class="row">
            <div class="col-12">
              <div class="control profile-img">
                @if (!updatedGroupList.chat_group_icon) {
                <empty-uname
                  [userName]="updatedGroupList.chat_group_name"
                  [detailProfile]="true"
                ></empty-uname>
                } @if (updatedGroupList.chat_group_icon) {
                <img [src]="profileUrl + updatedGroupList.chat_group_icon" />
                }
                <span class="img-options">
                  <div class="dropdown is-hoverable">
                    <div class="dropdown-trigger">
                      <i class="fa fa-camera"></i>
                    </div>
                    <div class="dropdown-menu" id="dropdown-menu4" role="menu">
                      <div class="dropdown-content">
                        <a class="dropdown-item">
                          <label class="file-label">
                            <input
                              class="file-input"
                              name="profile"
                              id="profile"
                              type="file"
                              (change)="onFileChange($event)"
                              [disabled]="selectedFileList.length > 0"
                              #fileInput
                              accept=".jpg, .jpeg, .png, .svg"
                            />
                            <span class="file-label">Update Picture</span>
                          </label>
                        </a>
                        @if (updatedGroupList.chat_group_icon) {
                        <a class="dropdown-item" (click)="deleteGroupProfile()"
                          >Remove Picture</a
                        >
                        }
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-3">
              <label class="label"
                >Title
                <span class="required">*</span>
              </label>
            </div>
            <div class="col-9">
              <input
                class="input"
                type="text"
                placeholder=""
                formControlName="chat_group_name"
              />
              <form-validation
                [control]="newGroupForm.controls.chat_group_name"
              ></form-validation>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-3">
              <label class="label">Description</label>
            </div>
            <div class="col-9">
              <textarea
                class="textarea"
                placeholder=""
                formControlName="chat_description"
                rows="2"
                (keydown)="keyDownHandler($event)"
              ></textarea>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-3">
              <label
                class="label class_list"
                data-tooltip="List of users who are already added to this Library"
                >Access Users
              </label>
            </div>
            <div class="col-9">
              @if (selectedIdList.length > 0) {
              <span class="display-ib mar-10-0">
                <em> {{ selectedIdList.length }} User selected </em>
              </span>
              }
              <button
                type="button"
                class="button is-small is-link pull-right"
                [disabled]="!newGroupForm.valid"
                (click)="openAddUserSection()"
              >
                Add More Users
              </button>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-12">
              <div class="field pos-relative scroll-bar">
                <div
                  class="panel pos-relative scroll-bar"
                  infinite-scroll
                  [infiniteScrollDistance]="modalScrollDistance"
                  [infiniteScrollThrottle]="modalScrollThrottle"
                  [scrollWindow]="false"
                  (scrolled)="onScrollDown()"
                >
                  <ul class="list-group">
                    @for (user of userList; track user) {
                    <li class="panel-block pos-relative">
                      <span class="col-6">
                        <span class="image is-32x32 mar-0-10 pull-left">
                          @if (!user.user_icon) {
                          <empty-uname
                            [userName]="user.full_name"
                            [liProfile]="true"
                          ></empty-uname>
                          } @if (user.user_icon) {
                          <img
                            [src]="profileUrl + user.user_icon"
                            class="image is-48x48"
                          />
                          }
                        </span>
                        <span class="pull-left">
                          {{ user.full_name }}<br />
                          @if (user.is_online) {
                          <p
                            class="is-size-7"
                            [ngClass]="{
                              'circle-grey': user.user_status === 0,
                              'circle-green': user.user_status === 1,
                              'circle-red': user.user_status === 2,
                              'circle-yellow': user.user_status === 3
                            }"
                          >
                            {{ user.status_name }}
                          </p>
                          } @if (!user.is_online) {
                          <p class="is-size-7 text-clr-grey">
                            {{ user.last_seen | amTimeAgo }}
                          </p>
                          }</span
                        >
                      </span>
                      <span class="col-6">
                        @if (!user.is_group_admin) {
                        <a
                          class="icon is-small icon-align is-pulled-right delete-user has-tooltip-left"
                          (click)="deleteGroupUser(user.user_id)"
                          data-tooltip="Remove User"
                        >
                          <i class="fa fa-trash" aria-hidden="true"></i>
                        </a>
                        }
                      </span>
                    </li>
                    }
                  </ul>
                  <!-- <div class="existing_student" *ngFor="let user of userList">
                        <label class="panel-block pos-relative groupUserList"  >
                          <div class="chat-user-status" >
                            <empty-uname [userName]="user.full_name" [liProfile]="true" *ngIf="!user.user_icon"></empty-uname>
                            <img [src]="profileUrl+user.user_icon" class="image is-48x48" *ngIf="user.user_icon">
                          </div>
                          <div class="mar-0-10">
                            <span class="display-b is-capitalized"> {{ user.full_name }}</span>
                            <p class="is-size-7" *ngIf="user.is_online" [ngClass]="{'circle-grey': user.user_status === 0, 'circle-green':user.user_status === 1, 'circle-red':user.user_status === 2, 'circle-yellow':user.user_status === 3}">{{user.status_name}}</p>
                            <p class="is-size-7 text-clr-grey" *ngIf="!user.is_online">{{user.last_seen | amTimeAgo}}</p>
                            <a class="button is-primary is-outlined is-small time-ago" *ngIf="user.is_group_admin" style="font-size: 10px;margin: 5px;">Admin</a>
                          </div>
                          <a class="icon is-small icon-align is-pulled-right delete-user has-tooltip-left" *ngIf="!user.is_group_admin" (click)="deleteGroupUser(user.user_id)" data-tooltip="Remove User">
                            <i class="fa fa-trash" aria-hidden="true"></i>
                          </a>
                        </label>
                      </div> -->
                  <pagination-loader
                    [showFetchLoader]="showPaginateSpinner"
                  ></pagination-loader>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-cancel"
          (click)="closeClassesDetails()"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="
            (newGroupForm.valid && !newGroupForm.dirty) || newGroupForm.invalid
          "
          (click)="updateGroupDetail(newGroupForm.value)"
        >
          Update
        </button>
      </div>
    </div>
  </div>
</div>
}
<div class="showAssignment">
  <div
    class="modal scroll-bar e-library-modal"
    [ngClass]="{ 'is-modal-active': domElementControl.showCreateElibrary }"
    appInfiniteScroll
    infinite-scroll
    [scrollWindow]="false"
    [infiniteScrollDistance]="modalScrollDistance"
    [infiniteScrollThrottle]="modalScrollThrottle"
  >
    <div class="modal-background"></div>
    <div class="modal-card">
      <div class="card">
        <form [formGroup]="libraryForm">
          <header class="card-header">
            <p class="card-header-title">File Upload</p>
            <button
              class="delete"
              aria-label="close"
              (click)="hideElibaryModal(upLoadedFileList)"
            ></button>
          </header>
          <div class="card-content">
            <div class="content">
              <div class="columns">
                <div class="column">
                  <div class="field post-attach-file">
                    <label for="" class="label">Attachment File</label>
                    <div
                      class="control profile-img"
                      [ngClass]="{ 'small-img': upLoadedFileList.length !== 0 }"
                    >
                      @if (upLoadedFileList.length === 0) {
                      <div>
                        <img
                          [src]="
                            '../../../assets/images/empty-state-attach.png'
                          "
                        />
                      </div>
                      } @if (upLoadedFileList.length !== 0) {
                      <div class="is-small">
                        @for (f of uploadFileIcons; track f) {
                        <div>
                          @if (f.name===upLoadedFileList[0].mimeType) {
                          <span>
                            <img
                              [src]="f.icons"
                              alt=""
                              width="35px"
                              height="35px"
                            />
                            {{ upLoadedFileList[0].name }}
                            <button
                              class="delete"
                              aria-label="Delete"
                              (click)="removeUploadFile(upLoadedFileList)"
                            ></button>
                          </span>
                          }
                        </div>
                        }
                      </div>
                      } @if (upLoadedFileList.length === 0) {
                      <span class="img-options">
                        <div class="dropdown is-hoverable">
                          <div
                            class="dropdown-trigger"
                            (click)="elibraryFileInput.click()"
                            data-tooltip="Upload File..."
                          >
                            <i class="fa fa-paperclip"></i>
                          </div>
                          <input
                            type="file"
                            name="msg-file"
                            style="display: none"
                            (change)="chooseUploadFile($event)"
                            #elibraryFileInput
                            accept=".pdf, .doc, .docx, .xlx, .xlsx, .mp3, .mp4, .avi, .wav, .txt, .png, .jpg, .jpeg, .ppt, pptx"
                          />
                        </div>
                      </span>
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <div class="field">
                    <label for="" class="label"
                      >Title
                      <span class="required">*</span>
                    </label>
                    <div class="control">
                      <input
                        type="text"
                        name=""
                        class="input"
                        placeholder="Title"
                        formControlName="title"
                      />
                      <form-validation
                        [control]="libraryForm.controls.title"
                      ></form-validation>
                    </div>
                  </div>
                </div>
              </div>
              <div class="columns is-clearfix">
                <div class="column">
                  <div class="has-text-right footer-elibrary">
                    <button
                      type="button"
                      class="button mar-0-5 is-small"
                      (click)="hideElibaryModal(upLoadedFileList)"
                    >
                      Cancel
                    </button>
                    @if (!showBtnSpinner) {
                    <button
                      type="button"
                      class="button is-link is-small"
                      (click)="createLibrary(libraryForm.value)"
                      [disabled]="
                        !libraryForm.valid || upLoadedFileList.length === 0
                      "
                    >
                      <i class="fa fa-upload"></i> Upload
                    </button>
                    } @if (showBtnSpinner) {
                    <a
                      class="button is-link is-loading is-small"
                      style="min-width: 100px"
                    ></a>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- User list modal -->
<div
  class="modalMobileView modal"
  [ngClass]="{ 'is-active': toggleModalSection }"
>
  <div class="modal-background"></div>
  <div class="modal-card">
    <div class="modal-card-head">
      <h4 style="font-weight: 700">Select More Users</h4>
      <h6 style="position: absolute; left: 17px; top: 28px; font-size: 13px">
        (Please select users you would like to add it to this policy)
      </h6>
    </div>
    <section class="modal-card-body">
      <div class="content">
        <div class="columns">
          <div class="column">
            <div class="field">
              <div class="panel-block">
                <p class="control has-icons-left">
                  <input
                    class="input is-small"
                    type="text"
                    placeholder="search"
                    [(ngModel)]="searchUser"
                    (keyup)="searchInList.next($event)"
                  />
                  <span class="icon is-small is-left">
                    <i class="fa fa-search"></i>
                  </span>
                </p>
                <span
                  class="icon is-small is-right search-return"
                  style="position: relative; right: -5px; top: -9px"
                  (click)="showSearchbox('close')"
                >
                  <i class="fa fa-times-circle"></i>
                </span>
              </div>

              <div
                class="panel panel-overflow scroll-bar"
                infinite-scroll
                [infiniteScrollDistance]="modalScrollDistance"
                [infiniteScrollThrottle]="modalScrollThrottle"
                [scrollWindow]="false"
                (scrolled)="onScrollDown()"
              >
                @for (user of listOfUsers; track user; let ind = $index) {
                <label
                  class="panel-block pos-relative"
                  (click)="selectUserId(ind, user.user_id)"
                >
                  <span class="image is-32x32 mar-0-10">
                    @if (!user.user_icon) {
                    <empty-uname
                      [userName]="user.full_name"
                      [detailHeadProfile]="true"
                    ></empty-uname>
                    } @if (user.user_icon && !user.is_group_admin) {
                    <img [src]="profileUrl + user.user_icon" />
                    }
                  </span>
                  {{ user.full_name }}
                  <!-- <span *ngIf="user.is_group_admin">Admin</span> -->
                  @if (user.is_selected && !user.is_group_admin) {
                  <span class="icon is-small icon-align is-pulled-right">
                    <i class="fa fa-check"></i>
                  </span>
                  }
                </label>
                }
                <pagination-loader
                  [showFetchLoader]="showPaginateSpinner"
                ></pagination-loader>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="modal-card-foot">
      <div class="column">
        <button type="button" class="button" (click)="clearAddUserSection()">
          Clear
        </button>
      </div>

      <div class="column has-text-right">
        <button
          type="button"
          class="button is-right mar-0-10"
          (click)="closeAddUserSection()"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="button is-link is-right"
          (click)="openAddUserSection()"
        >
          Add
        </button>
      </div>
    </div>
  </div>
</div>

<router-outlet></router-outlet>
